import { render, staticRenderFns } from "./SettingsMenuLayout.vue?vue&type=template&id=22930e7e&scoped=true"
import script from "./SettingsMenuLayout.vue?vue&type=script&lang=js"
export * from "./SettingsMenuLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22930e7e",
  null
  
)

export default component.exports